moment.locale(I18n.locale)
moment.RUBY_DATE_FORMAT = "YYYY-MM-DD"
moment.RUBY_DATETIME_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSSZ"
moment.RUBY_DATETIME_WITHOUT_TIMEZONE_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSS"
moment.TIME_FORMAT = "HH:mm"
moment.tz ? moment.tz.guess() : (console.error && console.error("moment.tz is missing"))


// WEBPACK FOOTER //
// ./app/webpack/frontend/config/moment.js